import {throttleEvent} from "./throttle-event.function";

export function mobileRealHeight() {
    // We listen to the resize event
    // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    const resizeViewport = function () {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    resizeViewport();
    window.addEventListener('resize', throttleEvent(() => {
        resizeViewport();
    }, 500));
}
